const exercisesTypes = [
  { value: "FLEXÃO DE BRAÇO", label: "Flexão de braço" },
  { value: "ABDOMINAL", label: "Abdominal" },
  { value: "FLEXIBILIDADE", label: "Flexibilidade" },
];

export const getExerciseFromValue = (value) => {
  const res = exercisesTypes.find((exercise) => value === exercise.value);
  return res;
};

export default exercisesTypes;
